<template>
  <transition name="fade">
    <div class="mod-req-app-100" v-if="!isNote">
      <div class="mod-req-app-container">
        <div class="title-wrapper">
          <div class="title-big title-color__red">
            EXTEND TO SAP
          </div>
        </div>
        <div>Nama Vendor</div>
        <div>
          <div class="half-input-wrapper">
            <input
              type="text"
              :value="
                `${$get($store, 'state.myRequest.detail.nama_vendor')}, ${$get(
                  $store,
                  'state.myRequest.detail.alias_profile'
                )}`
              "
              class="hiw-text mr10"
              disabled
            />
          </div>
        </div>
        <div>
          <div>Bisnis Unit</div>
          <div class="flex-space-between">
            <div>
              <input
                type="radio"
                value="2"
                v-model="bisnisUnit"
                class="mr10"
                disabled
              />
              <label>GEMS</label>
            </div>
            <div>
              <input
                type="radio"
                value="1"
                v-model="bisnisUnit"
                class="mr10"
                disabled
              />
              <label>BCE</label>
            </div>
            <div>
              <input
                type="radio"
                value="3"
                v-model="bisnisUnit"
                class="mr10"
                disabled
              />
              <label>BKES</label>
            </div>
          </div>
        </div>
        <div>
          <div>Catatan</div>
          <input
            type="text"
            class="input-100"
            :value="$get($store, 'state.myRequest.detail.note')"
            disabled
          />
        </div>
      </div>
      <div
        class="multy-btn-center"
        v-if="
          firstRoute($route.path) != 'myrequest' &&
            user_id != $store.state.userid
        "
      >
        <div class="flex-space-between">
          <div
            class="btn-small"
            v-if="
              $get($route, 'params.status') != 9 &&
                $get($route, 'params.status') != 5 &&
                $get($route, 'params.status') != 4 &&
                $get($store, 'state.role_id') == 1
            "
          >
            <div class="btn-wrapper btn-wrapper__red" @click="approve()">
              Approve
            </div>
          </div>
          <div
            class="btn-small"
            v-if="
              $get($route, 'params.status') == 9 &&
                $get($store, 'state.role_id') == 2
            "
          >
            <div class="btn-wrapper btn-wrapper__red" @click="approveHead()">
              Approve Head
            </div>
          </div>
          <div
            class="btn-small"
            v-if="
              $get($route, 'params.status') == 9 &&
                $get($store, 'state.role_id') == 2
            "
          >
            <div class="btn-wrapper btn-wrapper__red" @click="setReviewHead()">
              Review Head
            </div>
          </div>
          <div
            class="btn-small"
            v-if="
              $get($route, 'params.status') != 9 &&
                $get($route, 'params.status') != 5 &&
                $get($route, 'params.status') != 4 &&
                $get($store, 'state.role_id') == 1
            "
          >
            <div class="btn-wrapper btn-wrapper__red" @click="setReject()">
              Reject
            </div>
          </div>
          <!-- <div
            class="btn-small"
            v-if="
              $get($route, 'params.status') != 9 &&
                $get($route, 'params.status') != 5 &&
                $get($route, 'params.status') != 4
            "
          >
            <div class="btn-wrapper btn-wrapper__red" @click="postpone()">
              Postpone
            </div>
          </div> -->
        </div>
      </div>
    </div>

    <div class="mod-req-app-100" v-if="isNote">
      <div class="mod-req-app-container">
        <div class="title-wrapper">
          <div class="title-big title-color__red">
            EXTEND TO SAP
          </div>
        </div>
        <div>
          <div>Note</div>
          <input type="text" class="input-100" v-model="reviewNote" />
        </div>
      </div>
      <div class="multy-btn-center">
        <div class="flex-space-around">
          <div class="btn-small" v-if="isReviewHead">
            <div class="btn-wrapper btn-wrapper__red" @click="reviewHead()">
              Review Head
            </div>
          </div>
          <div class="btn-small" v-if="isReject">
            <div class="btn-wrapper btn-wrapper__red" @click="reject()">
              Reject
            </div>
          </div>
          <div class="btn-small">
            <div class="btn-wrapper btn-wrapper__red" @click="cancelReview()">
              Cancel
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      vendors: [],
      choosedVendor: [],
      bisnis_unit: 0,
      reviewNote: '',
      isNote: false,
      isReviewHead: false,
      isReject: false,
    }
  },
  created() {
    this.$store.dispatch('myRequest/sapDetail', this.$route.params.id)
  },
  computed: {
    user_id() {
      return this.$get(this.$store, 'state.myRequest.detail.user_id')
    },
    bisnisUnit() {
      return this.$get(this, '$store.state.myRequest.detail.bisnis_unit')
    },
  },
  methods: {
    setReviewHead() {
      this.isNote = true
      this.isReviewHead = true
    },
    setReject() {
      this.isNote = true
      this.isReject = true
    },
    cancelReview() {
      this.isNote = false
      this.isReviewHead = false
      this.isReject = false
    },
    async approve() {
      this.$store.dispatch('approvalSheet/approveVendor', {
        id: this.$get(this.$route, 'params.id'),
      })
    },
    async approveHead() {
      this.$store.dispatch('approvalSheet/approveHead', {
        id: this.$get(this.$route, 'params.id'),
      })
    },
    async reviewHead() {
      this.$store.dispatch('approvalSheet/reviewHead', {
        note: this.reviewNote,
        id: this.$get(this.$route, 'params.id'),
      })
    },
    async reject() {
      this.$store.dispatch('approvalSheet/rejectVendor', {
        note: this.reviewNote,
        id: this.$get(this.$route, 'params.id'),
      })
    },
    async postpone() {
      this.$store.dispatch('approvalSheet/postpone', {
        id: this.$get(this.$route, 'params.id'),
      })
    },
    closeModal() {
      this.$store.commit('modalReqApp/SET_VALUE', {
        name: 'modalViewExtend',
        value: false,
      })
    },
  },
}
</script>
